import React from "react";
import styled from "styled-components";
import { MdInfoOutline as MdInfo } from "react-icons/md";

import { ListItem } from "../ListItems";
import { ChapterMenuDiv } from "./styles";

export const ChapterButton = styled.div`
  cursor: pointer;
  font-size: 1em;
  height: 32px;
  width: 32px;
  border: solid 1px #c9c9c9;
  border-radius: 2px;
  margin: 0 4px 4px 0;
  transition: all 0.5s ease;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.primaryText};

  ${({ theme }) =>
    theme.darkMode
      ? `&:hover {
      border-color: white;
      background-color: rgba(255, 255, 255, 0.3);
      color: white;
    }`
      : `&:hover {
      border-color: ${theme.computedPrimary};
      background-color: ${theme.hightlightColor};
      color: ${theme.computedPrimary};
    }`}

  ${({ selected, theme }) =>
    selected &&
    (theme.darkMode
      ? `border-color: white;
         background-color: rgba(255, 255, 255, 0.3);
         color: white;`
      : `border-color: ${theme.computedPrimary};
          background-color: ${theme.hightlightColor};
          color: ${theme.computedPrimary};`)}
`;

const ChapterButtons = ({ book, chapter, handleChapterClick }) =>
  book.chapters
    .sort((a, b) => a.position - b.position)
    .map(chapterItem => (
      <ChapterButton
        onClick={() => handleChapterClick(chapterItem)}
        key={chapterItem.id}
        selected={chapterItem.id === chapter.currentChapterId}
      >
        {chapterItem.number === "intro" ? (
          <MdInfo size={24} />
        ) : (
          chapterItem.number
        )}
      </ChapterButton>
    ));

export const BookChapterList = ({
  book,
  bookId,
  chapter,
  handleBookClick,
  handleChapterClick,
  selectedBookId
}) => (
  <>
    <ListItem
      onClick={() => handleBookClick(book.id)}
      id={book.id}
      active={bookId === book.id}
    >
      {book.name}
    </ListItem>
    {selectedBookId === book.id && (
      <ChapterMenuDiv key={`${book.id}-chapters`}>
        {selectedBookId === book.id && (
          <ChapterButtons
            book={book}
            chapter={chapter}
            selectedBookId={selectedBookId}
            handleChapterClick={handleChapterClick}
          />
        )}
      </ChapterMenuDiv>
    )}
  </>
);
